import { httpsCallable } from "firebase/functions";
import { functions } from ".";

export const reportMissingSubscriptionEncounterIssue = async (subscriptionId, context = {}) => {
    const func = httpsCallable(functions, "reportmissingsubscriptionencounterissue", { timeout: 6000000 });

    const res = await func({
        subscriptionId,
        context
    });

    return res.data;
};
